import React from "react";
import {SmallStateIcon, StateName, StateTextColor} from "../../../../../components/StateStyles";
import Chip from "@material-ui/core/Chip";

const statusList = {
  "-1": "Отклонена",
  "0": "Новая",
  "1": "Принята в работу",
  "2": "Подтверждена",
  "3": "Переведена в архив"
};

const StatusTextCell = (cellData) => {
  let id = cellData.key.status;
  let name = statusList[id] || 'Статус не известен';

  return (
    <Chip color="primary"
          style={{ "background": StateTextColor(id)}}
          label={name}
          size="small"
          icon={SmallStateIcon(id)}/>
  );
};

export default StatusTextCell;
